/**
 * LinkedIn profile URLs as the speaker lookup needs them (ORB-571).
 *
 * LinkedIn serves the same profile on country subdomains (uk.linkedin.com, de.linkedin.com) and treats the
 * path case-insensitively, and people paste whatever their browser shows. The API's lookup accepts only
 * linkedin.com and www.linkedin.com, with a lowercase `in` as the first path segment, so both are
 * normalised here rather than sent to be refused.
 *
 * Anchored: the whole string must be a profile URL. Segments after the username are allowed, because the
 * API reads only the first two (…/in/username/details/experience/ is accepted there).
 */
const PROFILE_URL = /^https:\/\/(?:[a-z]{2,3}\.)?linkedin\.com\/in\/[^/?#\s]+(?:\/[^?#\s]*)?(?:[?#]\S*)?$/i
const HOST_AND_IN = /^https:\/\/(?:[a-z]{2,3}\.)?linkedin\.com\/in\//i

/** True for a LinkedIn profile URL on any LinkedIn host, e.g. https://uk.linkedin.com/in/username. */
export function isLinkedInProfileUrl(raw: string): boolean {
  return PROFILE_URL.test(raw.trim())
}

/** The same profile as https://www.linkedin.com/in/…, which is what the lookup accepts. Other input is returned trimmed. */
export function normalizeLinkedInProfileUrl(raw: string): string {
  const trimmed = raw.trim()
  return isLinkedInProfileUrl(trimmed) ? trimmed.replace(HOST_AND_IN, 'https://www.linkedin.com/in/') : trimmed
}
